import { Component } from '@angular/core';

@Component({
  selector: 'app-operators-dialog',
  templateUrl: './operators-dialog.component.html',
  styleUrls: ['./operators-dialog.component.scss'],
})
export class OperatorsDialogComponent {}
